import { useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function CustomizationDialog({ product, onClose }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: user?.name || "", phone: user?.phone || "", finish: product.finish || "", details: "",
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!user?.user_id) { toast.error("Please sign in to request customization"); navigate("/login"); return; }
    if (!form.name || !form.phone || !form.details) { toast.error("Please fill all fields"); return; }
    await api.post("/customization-requests", {
      product_id: product.id, vendor_id: product.vendor_id, details: form.details,
      finish: form.finish, name: form.name, phone: form.phone,
    });
    toast.success("Request sent — awaiting vendor confirmation");
    onClose();
    navigate("/account/customizations");
  };

  return (
    <div className="fixed inset-0 z-[70] grid place-items-center p-4">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-lg rounded-3xl bg-white p-7" data-testid="customization-dialog">
        <button onClick={onClose} className="absolute right-5 top-5"><X className="h-5 w-5" /></button>
        <h3 className="text-2xl font-extrabold text-midnight">Request Customization</h3>
        <p className="mt-1 text-sm text-muted-foreground">{product.name}</p>
        <div className="mt-3 rounded-xl bg-secondary p-3 text-xs text-muted-foreground">
          Your request goes to the vendor for confirmation. Flow: <b className="text-midnight">Request → Vendor Confirmation → Final Quote → Your Approval → Order</b>. Nothing is confirmed until you approve the quote.
        </div>
        <div className="mt-5 space-y-3">
          <input value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Your name" data-testid="custom-name" className="w-full rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
          <input value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Phone number" data-testid="custom-phone" className="w-full rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
          <input value={form.finish} onChange={(e) => set("finish", e.target.value)} placeholder="Preferred finish (optional)" data-testid="custom-finish" className="w-full rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
          <textarea value={form.details} onChange={(e) => set("details", e.target.value)} placeholder="Describe your customization (size, colour, material preferences)…" rows={4} data-testid="custom-details" className="w-full rounded-xl border border-border px-4 py-3 text-sm outline-none focus:border-gold" />
        </div>
        <button onClick={submit} data-testid="custom-submit" className="mt-5 w-full rounded-full bg-mart-wood py-3.5 font-bold text-white hover:opacity-90 transition-opacity">Send Request to Vendor</button>
      </div>
    </div>
  );
}
